<div class="container">
    <a id="title-window" [routerLink]="['/']">{{constants.WINDOW_SWAP_TXT}}</a>
    <div class="video-list">
        <div class="row" *ngIf="loading">
            <div class="col-lg-3 col-md-4 col-6" *ngFor="let item of skeltonArray">
                <button class="bookmard-window">
                    <img name="{{ item.videoId }}" class="card-img-top" [src]="item" alt="Card image cap" />
                </button>
                <div class="card-body bookmark-card"></div>
            </div>
        </div>

        <div class="row" *ngIf="!loading">
            <div class="col-lg-3 col-md-4 col-6" *ngFor="let item of videos">
                <button class="bookmard-window" (click)="getClickedVideo($event)">
                    <img name="{{ item.url1 }}" class="card-img-top" [src]="item?.thumbnail" alt="Card image cap" />
                </button>
                <div class="card-body bookmark-card">
                    <h6 class="card-title bookmark-title">{{ item.author }}'s window</h6>
                    <a href="http://maps.google.co.in/maps?q={{ item.cityLocation }}" target="_blank"
                        class="bookmark-sub-title">{{
                        item.cityLocation }}</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- <app-home [from]="from"></app-home> -->